import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { ErrorRequired } from '../FormFields/ErrorRequired';
import { ErrorEmailInvalid } from '../FormFields/ErrorEmailInvalid';

export class EmailFormInput extends React.Component {
  render = () => {
    const inputClasses = classNames({
      'form-control': true,
      'is-invalid': this.props.isDisplayRequiredFailed || this.props.isDisplayInvalid,
    });

    return (
    <div className="mb-3" >
      <label className="form-label bold" htmlFor={this.props.id}>
        { this.props.labelText }
      </label>

      <input type="email" 
        className={inputClasses}
        value={this.props.email || ''}
        onChange={this.props.onChange}
        name={this.props.emailPropertyName}
        id={this.props.id}
      />

      <ErrorRequired isDisplay={this.props.isDisplayRequiredFailed } />
      <ErrorEmailInvalid isDisplay={this.props.isDisplayInvalid } />
    </div>
    );
  }
}

EmailFormInput.propTypes = {
  labelText: PropTypes.string,
  email: PropTypes.string,
  onChange: PropTypes.func,
  isDisplayRequiredFailed: PropTypes.bool,
  isDisplayInvalid: PropTypes.bool,
  emailPropertyName: PropTypes.string.isRequired,
  id: PropTypes.string,
};
